<template>
  <TelaCheia v-model="tela_cheia" :titulo="titulo">
    <span v-show="!tela_cheia && !ocultar_titulo" class="title font-weight-regular" v-text="titulo" />

    <sys-data-table
      :height="!tela_cheia ? height : height_tabela_tela_cheia"
      :item-height="item_height"
      :headers="headers"
      :items="ITEMS_COMPUTED"
      item-key="sku"
      :search="pesquisa"
      hide-border-bottom-tr
      :show-select="showSelect"
      :class="{'pl-2 pt-2': tela_cheia}"
      content-class="sys-data-table-blue-hover-linha text-black"
      :item-class="classesCssLinha"
      :loading="data_table_departamentos_carregando_dados"
      @click:row="$emit('click:row', $event.row)"
      @update:headers="ev => $emit('update:headers', ev)"
    >
      <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope">
        <slot :name="slot" v-bind="scope"/>
      </template>

      <template #top>
        <TopoTabela
          v-model="tela_cheia"
          :habilitar_exportacao_excel="BOTAO_EXCEL_DASHBOARD"
          :parametros_excel="PARAMETROS_CALLBACK"
          :departamento_analise="(departamento > 0) ? (itens[0] || {}) : undefined"
          :ocultar_tela_cheia="ocultar_tela_cheia"
          :headers="headers"
          :items="ITEMS_COMPUTED"
          :ocultar_filtros_topo="ocultar_filtros_topo"
          :ocultar_filtro_pesquisa="ocultar_filtro_pesquisa"
          @atualizacao:colunas-tabela="headers = $event"
          @atualizacao:pesquisa="pesquisa = $event"
          @atualizacao:filtros="filtros = $event"
          @click:refresh="iniciarCarregamentoDados"
        >
          <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope">
            <slot :name="slot" v-bind="scope"/>
          </template>
        </TopoTabela>
      </template>

      <template #item.nivel_servico="{item}">
        <slot name="item.nivel_servico" :item="item">
          <template v-if="item.nivel_expancao >= NIVEL_EXIBICAO_PESO_COMPRA">
            <NivelServico
              :nivel_servico="item.nivel_servico"
              :label="`categoria de ${item.nivel_servico}`.toLocaleLowerCase()"
            />
          </template>
        </slot>
      </template>

      <template #item.idproduto="{item}">
        <slot name="item.idproduto" :item="item">
          <span v-text="item.idproduto || item.idcategoria || item.idsecao || item.iddepartamento || '-'" />
        </slot>
      </template>

      <template #item.descricao_linha="{item}">
        <div class="d-flex align-center ml-n2">
          <MarcadorDeIdentacao v-if="!ocultar_marcador_identacao" :linha="item" :altura="item_height" class="ml-2" />

          <slot name="item.descricao_linha.prepend" :item="item" />

          <template v-if="item.idproduto">
            <DetalhamentoProduto :produto="{id_grupo: grupo, id_produto: item.idproduto}" />
          </template>

          <template v-if="item.nivel_expancao !== qtd_niveis_expancao && !item.linha_totalizadora">
            <v-btn icon @click.stop="expandirLinha(item)" small class="ml-n1">
              <v-progress-circular
                v-if="ultima_linha_clicada
                  && ultima_linha_clicada.index_unico_por_linha === item.index_unico_por_linha
                  && data_table_departamentos_carregando_dados
                "
                indeterminate
                color="red"
                size="15"
                width="2"
              />

              <template v-else>
                <v-icon v-if="linhaEstaExpandida(item)">mdi-chevron-down</v-icon>
                <v-icon v-else>mdi-chevron-right</v-icon>
              </template>
            </v-btn>
          </template>

          <span class="cursor-help">
            <v-icon v-if="item.tipo_compra === 'FC'" small left title="Categoria em forecast">mdi-clock</v-icon>
            <v-icon v-else-if="item.tipo_compra === 'TR'" small left title="Categoria em trânsito">mdi-truck</v-icon>
          </span>

          <span
            :class="{'ml-6': item.linha_totalizadora}"
            v-text="item.descricao_departamento || item.descricao_secao || item.descricao_categoria || item.descricao_produto"
          />
        </div>
      </template>

      <template #item.estoque_loja="{item}">
        <div class="d-flex align-center">
          <span v-text="item.estoque_loja" />
          <EstoquePorLojaDialog :parametros="{...item, grupo: grupo}" tipo_filiais="lojas" :disabled="data_table_departamentos_carregando_dados">
            <template #topo-tabela>
              <DescricaoNivelLinha :linha="item" />
            </template>
          </EstoquePorLojaDialog>
        </div>
      </template>

      <template #item.estoque_cd="{item}">
        <div class="d-flex align-center">
          <span v-text="item.estoque_cd" />
          <EstoquePorLojaDialog :parametros="{...item, grupo: grupo}" tipo_filiais="cds" :disabled="data_table_departamentos_carregando_dados">
            <template #topo-tabela>
              <DescricaoNivelLinha :linha="item" />
            </template>
          </EstoquePorLojaDialog>
        </div>
      </template>

      <template #item.estoque_loja_em_preco_de_custo="{item}">
        <div class="d-flex align-center">
          <span v-text="item.estoque_loja_em_preco_de_custo" />
          <EstoquePorLojaDialog :parametros="item" :disabled="data_table_departamentos_carregando_dados" tipo_filiais="lojas">
            <template #topo-tabela>
              <DescricaoNivelLinha :linha="item" />
            </template>
          </EstoquePorLojaDialog>
        </div>
      </template>

      <template #item.dias_de_cobertura_da_cd="{item, value}">
        <div class="d-flex align-center">
          <span v-text="value" />
          <CoberturaCdEmExcesso v-if="item.em_excesso" :disabled="data_table_departamentos_carregando_dados" />
        </div>
      </template>

      <template #item.data_da_ultima_entrada="{item}">
        <span v-if="!item.data_da_ultima_entrada" class="text-gray-100">sem entrada</span>
        <v-tooltip v-else open-delay="500" top>
          <template #activator="{ on, attrs }">
            <div class="d-flex">
              <span v-bind="attrs" v-on="on" v-text="`há ${item.qtd_dias_da_ultima_entrada} dias`" />

              <UltimasCompras :filtros="{...item, grupo: grupo}">
                <template #topo-tabela>
                  <DescricaoNivelLinha :linha="item" />
                </template>
              </UltimasCompras>
            </div>
          </template>

          <span v-text="`A última entrada foi feita em ${item.data_da_ultima_entrada}`" />
        </v-tooltip>
      </template>

      <template #item.data_da_ultima_venda="{item}">
        <span v-if="!item.data_da_ultima_venda" class="text-gray-100">sem venda</span>
        <v-tooltip v-else open-delay="500" top>
          <template #activator="{ on, attrs }">
            <div class="d-flex">
              <span v-bind="attrs" v-on="on" v-text="`há ${item.qtd_dias_sem_vender} dias`" />

              <VendasUltimosMeses :filtros="{...item, grupo: grupo}">
                <template #topo-corpo>
                  <DescricaoNivelLinha class="pt-3 pl-2" :linha="item" />
                </template>
              </VendasUltimosMeses>
            </div>
          </template>
          <span v-text="`A última venda foi feita em ${item.data_da_ultima_venda}`" />
        </v-tooltip>
      </template>

      <template #item.estoque="{item}">
        <div class="d-flex align-center">
          <span v-text="Helpers.formatarValor(item.estoque)" />
          <EstoquePorLojaDialog :parametros="item" :disabled="data_table_departamentos_carregando_dados">
            <template #topo-tabela>
              <DescricaoNivelLinha :linha="item" />
            </template>
          </EstoquePorLojaDialog>
        </div>
      </template>

      <template #item.estoque_em_preco_de_custo="{item}">
        <div class="d-flex align-center">
          <span v-text="item.estoque_em_preco_de_custo" />
          <EstoquePorLojaDialog :parametros="item" :disabled="data_table_departamentos_carregando_dados">
            <template #topo-tabela>
              <DescricaoNivelLinha :linha="item" />
            </template>
          </EstoquePorLojaDialog>
        </div>
      </template>

      <template #item.projecao_de_venda="{item}">
        {{ Helpers.formatarValorComCasas(item.projecao_de_venda, 1) }}
      </template>

      <template #item.desvio_padrao_consumo="{value}">
        {{ Helpers.formatarValorComCasas(value, 1) }}
      </template>

      <template #item.prazo_medio_recebimento_em_dias="{item}">
        {{ `${Helpers.formatarValorComCasas(item.prazo_medio_recebimento_em_dias, 1)} dias` }}
      </template>

      <template #item.qtde_pendente="{item}">
        <div class="d-flex">
          {{ Helpers.formatarValor(item.qtde_pendente) }}

          <PedidosPendente v-if="item.qtde_pendente > 0" :filtros="{...item, grupo: grupo}">
            <template #topo-tabela>
              <DescricaoNivelLinha :linha="item" />
            </template>
          </PedidosPendente>
        </div>
      </template>

      <template #item.preco_custo="{item}">
        <slot name="item.preco_custo" :item="item" />
      </template>

      <template #item.sugestao_compra_em_preco_de_custo="{item}">
        <slot
          name="item.sugestao_compra_em_preco_de_custo"
          :item="item"
          :custo_total_departamento_analise="TOTAL_PRECO_CUSTO_DEPARTAMENTO_ANALISE"
        >
          {{ item.sugestao_compra_em_preco_de_custo }}
        </slot>
      </template>

      <template #item.cobertura_estoque_futura="{item}">
        <div class="d-flex">
          <slot name="item.cobertura_estoque_futura" :item="item">
            <CalculaCoberturaEstoqueFutura
              :item="{
                estoque: item.estoque,
                consumo_medio_mensal: item.projecao_de_venda,
                sugestao: item.sugestao_compra_em_quantidade,
                estoque_transito: item.qtde_pendente,
                tempo_medio_ressuprimento: item.prazo_medio_recebimento_em_dias,
                multiplo_compra: 1
              }"
            />
          </slot>
        </div>
      </template>

      <template #item.sugestao_compra_em_quantidade="{item}">
        <slot
          name="item.sugestao_compra_em_quantidade"
          :item="item"
          :item_nivel_acima="itemNivelAcima(item)"
          :qtd_sugestao_departamento_analise="TOTAL_QTD_SUGESTAO_DEPARTAMENTO_ANALISE"
        >
          {{ `${item.sugestao_compra_em_quantidade} ${item.unidade_compra}` }}
        </slot>
      </template>

      <template #item.sugestao_compra_em_quantidade_fixo="{item}">
        <slot name="item.sugestao_compra_em_quantidade_fixo" :item="item" :item_nivel_acima="itemNivelAcima(item)" />
      </template>

      <template #footer="{countItems}">
        <Rodape :countItems="countItems">
          <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope">
            <slot :name="slot" v-bind="scope"/>
          </template>
        </Rodape>
      </template>
    </sys-data-table>
  </TelaCheia>
</template>

<script>
import headers_padrao from "./Headers.js";
import Responsividade from "../../../../helpers/ResponsiveHeight.js";
import TopoTabela from "./Componentes/TopoTabela.vue";
import Rodape from "./Componentes/Rodape.vue";
import TelaCheia from "../../../utils/TelaCheia.vue";
import MarcadorDeIdentacao from "./Componentes/MarcadorDeIdentacao.vue";
import EstoquePorLojaDialog from "../../../dashboard/departamentos/EstoquePorLojaDialog.vue";
import CoberturaCdEmExcesso from "../../../dashboard/departamentos/CoberturaCdEmExcesso.vue";
import {NIVEIS_DE_EXPANCAO} from "./NiveisDeExpancao.js";
import {formatarLinhas} from "./FormatarLinhas.js";
import {logout} from "../../../../helpers";
import {categoria_selecionada} from "../../../compra/departamentos/helpers/CategoriaSelecionado";
import {data_table_departamentos_carregando_dados} from "./CarregandoDados.js";
import NivelServico from "./Componentes/NivelServico";
import DetalhamentoProduto from "../../../produto/detalhes/Index.vue";
import CalculaCoberturaEstoqueFutura from "../../../compra/CalculaCoberturaEstoqueFutura";
import PedidosPendente from "../../../compra/departamentos/DetalhesCategoria/PedidosPendente.vue";
import UltimasCompras from "../../../compra/departamentos/DetalhesCategoria/UltimasCompras.vue";
import DescricaoNivelLinha from "./Componentes/DescricaoNivelLinha";
import VendasUltimosMeses from "../../../compra/departamentos/DetalhesCategoria/VendasUltimosMeses";

const QTD_DELETAR = 0;

export default {
  name: "SysDataTableDepartamentos",
  mixins: [Responsividade, categoria_selecionada, data_table_departamentos_carregando_dados],
  components: {
    VendasUltimosMeses,
    DescricaoNivelLinha,
    PedidosPendente,
    NivelServico,
    TopoTabela,
    TelaCheia,
    MarcadorDeIdentacao,
    Rodape,
    EstoquePorLojaDialog,
    CoberturaCdEmExcesso,
    DetalhamentoProduto,
    CalculaCoberturaEstoqueFutura,
    UltimasCompras
  },
  props: {
    height: Number,
    grupo: {
      type: [String, Number],
      default: 0
    },
    filial: {
      type: [String, Number],
      default: 9999
    },
    departamento: {
      type: [String, Number],
      default: null
    },
    card: {
      type: [String],
      default: ''
    },
    linhas_removidas: {
      type: Array,
      default: () => ([])
    },
    ocultar_titulo: {
      type: Boolean,
      default: false
    },
    exibir_colunas_opcionais: {
      type: Boolean,
      default: false
    },
    ocultar_tela_cheia: {
      type: Boolean,
      default: false
    },
    callbackNivel1: {
      type: Function,
      required: true
    },
    callbackNivel2: {
      type: Function,
      required: true
    },
    callbackNivel3: Function,
    callbackNivel4: Function,
    qtd_niveis_expancao: {
      type: Number,
      default: 4
    },
    habilitar_exportacao_excel: {
      type: Boolean,
      default: () => false
    },
    cabecalhos_personalizado: {
      type: Array,
      default: () => headers_padrao
    },
    itemClass: {
      type: Function,
      default: () => ({})
    },
    titulo: {
      type: String,
      default: 'Departamentos'
    },
    formatar_linhas: {
      type: Boolean,
      default: true
    },
    ocultar_filtros_topo: {
      type: Boolean,
      default: false
    },
    ocultar_filtro_pesquisa: {
      type: Boolean,
      default: false
    },
    ocultar_marcador_identacao: Boolean,
    showSelect: Boolean,
  },
  data: () => ({
    tela_cheia: false,
    item_height: 50,
    pesquisa: "",
    filtros: {
      fornecedores: [],
      compradores: [],
      status: ""
    },
    headers: [],
    itens: [],
    NIVEIS_DE_EXPANCAO,
    linhas_expandidas: [],
    ultima_linha_clicada: null,
    habilitar_exportacao_excel_categorias: false
  }),
  computed: {
    BOTAO_EXCEL_DASHBOARD() {
      return this.habilitar_exportacao_excel || this.habilitar_exportacao_excel_categorias;
    },

    ITEMS_COMPUTED() {
      if (this.departamento > 0 && this.itens.length === 1 && !this.data_table_departamentos_carregando_dados) {
        return [];
      }

      return this.itens;
    },
    height_tabela_tela_cheia(){
      return parseInt(this.alturaDaJanela - 150);
    },
    PARAMETROS_CALLBACK() {
      const parametros = {
        grupo: this.grupo,
        filial: this.filial,
        ...this.filtros
      }

      if (this.card && this.card.length > 0) {
        parametros.card = this.card;
      }

      if (this.departamento && this.departamento > 0) {
        parametros.iddepartamento = this.departamento;
      }

      return parametros;
    },
    TOTAL_QTD_SUGESTAO_DEPARTAMENTO_ANALISE() {
      // remover essas funcoes de totais para arquivos que necessitam delas
      if (!this.departamento) return 0;

      const callback = (a, b) => {
        if (b.nivel_expancao !== NIVEIS_DE_EXPANCAO.SEGUNDO) return a;

        return a + parseFloat(b.sugestao_compra_em_quantidade || 0);
      };

      return this.itens.reduce(callback, 0);
    },
    TOTAL_PRECO_CUSTO_DEPARTAMENTO_ANALISE() {
      // remover essas funcoes de totais para arquivos que necessitam delas
      if (!this.departamento) return 0;

      const callback = (a, b) => {
        if (b.nivel_expancao !== NIVEIS_DE_EXPANCAO.SEGUNDO) return a;
        this.habilitar_exportacao_excel_categorias = true;

        return a + parseFloat(b.preco_custo * b.sugestao_compra_em_quantidade);
      };

      return this.itens.reduce(callback, 0);
    },
    NIVEL_EXIBICAO_PESO_COMPRA() {
      if (this.departamento > 0) return NIVEIS_DE_EXPANCAO.SEGUNDO;
      return NIVEIS_DE_EXPANCAO.TERCEIRO;
    }
  },
  watch: {
    cabecalhos_personalizado: {
      handler(valor) {
        this.headers = valor;
      },
      immediate: true
    },
    ultima_linha_clicada(linha) {
      if (!this.ultima_linha_clicada) return;

      if (this.linhaEstaExpandida(linha)) {
        this.linhas_expandidas = this.linhas_expandidas
          .filter(item => item.index_unico_por_linha !== linha.index_unico_por_linha)
      } else {
        this.linhas_expandidas.push(linha);
      }
    },
    PARAMETROS_CALLBACK: {
      handler() {
        this.iniciarCarregamentoDados();
      },
      immediate: true
    },
    linhas_removidas() {
      if (!this.linhas_removidas && this.linhas_removidas.length <= 0) return;

      const callback = item => {
        return !this.linhas_removidas.some(linha_removida => {
          const index_parte_valida = linha_removida.index_unico_por_linha.replace(/-#/g, "");
          return item.index_unico_por_linha.startsWith(index_parte_valida);
        });
      };

      this.itens = this.itens.filter(callback);
    },
    itens() {
      this.$emit('itens-data-table', this.itens);
    }
  },
  mounted() {
    this.$emit('callback-carregar-dados', {callback: this.iniciarCarregamentoDados});
  },
  methods: {
    iniciarCarregamentoDados() {
      this.data_table_departamentos_carregando_dados = true;
      this.ultima_linha_clicada = null;
      this.linhas_expandidas = [];
      this.itens = [];

      this.executarPrimeiroNivelExpancao().finally(this.finalizarCarregamentoDadosIniciais);
    },
    async executarPrimeiroNivelExpancao() {
      const resultado = await this.callbackNivel1(this.PARAMETROS_CALLBACK).catch(logout);

      if (!resultado) return;

      const itens_primeiro_nivel = (this.departamento > 0) ? [resultado] : resultado;

      if (itens_primeiro_nivel.length === 0) return;

      this.itens = formatarLinhas(itens_primeiro_nivel, NIVEIS_DE_EXPANCAO.PRIMEIRO, this.callbackNivel2, this.formatar_linhas);
    },
    finalizarCarregamentoDadosIniciais() {
      this.data_table_departamentos_carregando_dados = false;

      if (this.departamento > 0 && this.itens.length > 0) {
        const [departamento] = this.itens;

        departamento.index_of = 0;
        this.ultima_linha_clicada = departamento;
        this.executarCallbackLinha(departamento);
      }
    },
    async executarCallbackLinha(linha) {
      if (!linha.fn_expandir_linha) return;

      this.data_table_departamentos_carregando_dados = true;

      const novo_itens = await linha.fn_expandir_linha(linha, this.PARAMETROS_CALLBACK).catch(logout);
      const nivel_expancao_itens = (linha.nivel_expancao + 1);

      let callback_proximo_nivel = undefined;

      if (this.qtd_niveis_expancao > nivel_expancao_itens) {
        callback_proximo_nivel = this[`callbackNivel${nivel_expancao_itens + 1}`];
      }

      this.atualizarItensTabela(nivel_expancao_itens, novo_itens, callback_proximo_nivel);

      this.data_table_departamentos_carregando_dados = false;
    },
    atualizarItensTabela(nivel_expancao, itens, callbackExpancao) {
      const index_nivel_anterior = this.ultima_linha_clicada
        ? (this.ultima_linha_clicada.index_of + 1)
        : 0;

      this.itens.splice(index_nivel_anterior, QTD_DELETAR, ...formatarLinhas(itens, nivel_expancao, callbackExpancao, this.formatar_linhas));
    },
    linhaEstaExpandida(linha) {
      return this.linhas_expandidas.some(item => item.index_unico_por_linha === linha.index_unico_por_linha);
    },
    classesCssLinha(linha) {
      const categoria_detalhes_tela_compras = linha.nivel_expancao === NIVEIS_DE_EXPANCAO.SEGUNDO
        && this.categoria_selecionada
        && linha.index_unico_por_linha === this.categoria_selecionada.index_unico_por_linha;

      return {
        'font-weight-medium': linha.linha_totalizadora,
        'sys-data-table-blue-linha-ativa': this.linhaEstaExpandida(linha) || categoria_detalhes_tela_compras,
        'cursor-pointer': this.departamento && linha.nivel_expancao === NIVEIS_DE_EXPANCAO.SEGUNDO,
        'cursor-progress': this.data_table_departamentos_carregando_dados,
        ...this.itemClass(linha, this.itemNivelAcima(linha)),
      }
    },
    expandirLinha(row) {
      if (this.data_table_departamentos_carregando_dados) return;

      if (this.departamento > 0 && row.nivel_expancao === NIVEIS_DE_EXPANCAO.PRIMEIRO) {
        return;
      }

      if (row.nivel_expancao === this.qtd_niveis_expancao) {
        return;
      }

      this.ultima_linha_clicada = Object.assign({}, row);

      if (this.linhaEstaExpandida(row)) {
        this.removerItensNivelMenor();
        return;
      }

      this.executarCallbackLinha(row);
    },
    removerItensNivelMenor() {
      this.itens = this.itens.filter(({index_unico_por_linha, nivel_expancao}) => {
        if (index_unico_por_linha === this.ultima_linha_clicada.index_unico_por_linha && nivel_expancao <= this.ultima_linha_clicada.nivel_expancao) return true;

        const index_parte_valida = this.ultima_linha_clicada.index_unico_por_linha.replace(/-#/g, "");
        
        return !index_unico_por_linha.startsWith(index_parte_valida);
      })
    },
    itemNivelAcima(linha) {
      // por enquanto só ta funcionando por categoria
      return this.ITEMS_COMPUTED.find(item => item.idcategoria === linha.idcategoria && !item.idproduto);
    }
  }
}
</script>

<style scoped>

</style>
